import moment from 'moment'
import React from 'react'
import { Button, StopsCard } from '../../../components'
import { weekDaysByLanguage } from '../../../helpers'
import { images } from '../../../images'
import { IBookingScheduler, IFavoriteResponse } from '../../../models'
import { LiteralsService } from '../../../services'
import StyledSection from './styles'

interface IProps {
  // either an existing scheduler, or a favorite that has none yet
  bookingScheduler?: IBookingScheduler
  favorite?: IFavoriteResponse
  onCreate?: (favorite: IFavoriteResponse) => void
  onEdit?: (bookingScheduler: IBookingScheduler) => void
  onDelete?: (bookingScheduler: IBookingScheduler) => void
}

// The backend stores the days as English uppercase names; show them in the reader's language.
const shortDays = (daysOfWeek: string[]): string => {
  const locale = weekDaysByLanguage[LiteralsService.getLanguage()] || weekDaysByLanguage.en
  const english = weekDaysByLanguage.en.long

  return daysOfWeek
    .map(day => {
      const index = english.indexOf(day)
      return index !== -1 ? locale.short[index] : day
    })
    .join(', ')
}

const period = (bookingScheduler: IBookingScheduler): string => {
  const start = bookingScheduler.startDate ? moment(bookingScheduler.startDate).format('L') : ''
  const end = bookingScheduler.endDate ? moment(bookingScheduler.endDate).format('L') : ''
  if (!start && !end) return ''

  return `${ start } - ${ end } · `
}

export const SchedulerCard: React.FC<IProps> = ({ bookingScheduler, favorite, onCreate, onEdit, onDelete }) => {
  if (bookingScheduler) {
    const repeat = LiteralsService.get(bookingScheduler.repeatEvery === 1 ? 'every_week' : 'every_2_weeks', true)

    return (
      <StyledSection>
        <header>
          <h4>{ bookingScheduler.name }</h4>
          <button className="delete" onClick={ () => onDelete && onDelete(bookingScheduler) }>
            <img src={ images.delete } alt={ LiteralsService.get('delete', true) } />
          </button>
        </header>
        <section className="content">
          <StopsCard
            inStopName={ bookingScheduler.favorite.inStop.properties.name }
            outStopName={ bookingScheduler.favorite.exitStop.properties.name }
          />
          <p className="summary">
            { `${ period(bookingScheduler) }${ repeat } · ${ shortDays(bookingScheduler.daysOfWeek) } · ${ bookingScheduler.bookingTime }` }
          </p>
        </section>
        <footer>
          <Button
            onPress={ () => onEdit && onEdit(bookingScheduler) }
            title={ LiteralsService.get('editBookingSchedulerBooking', true) }
            styles={{ width: '220px' }}
            upper
          />
        </footer>
      </StyledSection>
    )
  }

  if (!favorite) return null

  return (
    <StyledSection className="empty">
      <header>
        <h4>{ favorite.name }</h4>
      </header>
      <section className="content">
        <StopsCard
          inStopName={ favorite.inStop.properties.name }
          outStopName={ favorite.exitStop.properties.name }
        />
      </section>
      <footer>
        <Button
          onPress={ () => onCreate && onCreate(favorite) }
          title={ LiteralsService.get('createBookingSchedulerBooking', true) }
          styles={{ width: '220px' }}
          filled
          upper
        />
      </footer>
    </StyledSection>
  )
}
